/*
  Scroll-reveal animations for sections marked `.animate-section`.

  Performance rules:
  - The first section inside <main> (the above-the-fold / LCP candidate) is never hidden
    behind a reveal animation: it is shown immediately so the LCP element paints as soon as
    its image arrives.
  - Visitors who set `prefers-reduced-motion` get everything shown immediately.
  - If the browser lacks IntersectionObserver, everything is shown immediately.
*/
(function () {
  const script = document.currentScript;
  const repeat = script && script.dataset.repeat === 'true';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(root) {
    root.querySelectorAll('.animate-section').forEach((el) => el.classList.add('animate--shown'));
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    document.addEventListener('DOMContentLoaded', () => showAll(document));
    return;
  }

  let observer;
  function getObserver() {
    if (observer) return observer;
    const stickyAtc = document.querySelector('.sticky-atc');
    let bottomMargin = 50;
    if (stickyAtc) bottomMargin += stickyAtc.clientHeight;
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate--shown');
            if (!repeat) observer.unobserve(entry.target);
          } else if (repeat) {
            entry.target.classList.remove('animate--shown');
          }
        });
      },
      { rootMargin: `0px 0px -${bottomMargin}px 0px` }
    );
    return observer;
  }

  function initAnimations(root = document, isThemeEditorEvent = false) {
    const elements = root.querySelectorAll('.animate-section');
    if (!elements.length) return;

    // First section in <main> on the initial page load: show immediately (LCP protection).
    const main = document.getElementById('MainContent');
    const firstSection = main && main.querySelector('.shopify-section');
    const firstAnimated = firstSection && firstSection.querySelector('.animate-section');

    elements.forEach((element) => {
      if (isThemeEditorEvent || element === firstAnimated || (firstAnimated && firstAnimated.contains(element))) {
        element.classList.add('animate--shown');
        return;
      }
      getObserver().observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAnimations());
  } else {
    initAnimations();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAnimations(event.target, true));
    document.addEventListener('shopify:section:reorder', () => initAnimations(document, true));
  }
})();
